import React, { useState, useEffect, useRef } from 'react';
import { IMAGE_PATHS } from '../config/images';

const PainPointsSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const mobileRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Animação automática para mobile
  useEffect(() => {
    if (!isMobile || !mobileRef.current) return;

    let animationId;
    let scrollPos = 0;
    const scrollSpeed = 0.5; // Velocidade reduzida pela metade para melhor legibilidade

    const animate = () => {
      const container = mobileRef.current;
      if (!container) return;

      const maxScroll = container.scrollWidth - container.clientWidth;

      if (maxScroll > 0) {
        scrollPos += scrollSpeed;

        if (scrollPos >= maxScroll) {
          // Reset suave para o início
          scrollPos = 0;
          container.scrollLeft = 0;
        } else {
          container.scrollLeft = scrollPos;
        }
      }

      animationId = requestAnimationFrame(animate);
    };

    // Pequeno delay para garantir que o DOM esteja pronto
    const startAnimation = setTimeout(() => {
      animate();
    }, 100);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      clearTimeout(startAnimation);
    };
  }, [isMobile]);

  const reviews = [
    {
      id: 1,
      image: IMAGE_PATHS.patricia,
      alt: "Roberta Araújo",
      text: "Tudo tem um recomeço! Eu resolvi tentar de novo depois de VÁRIAS dietas… ainda bem que encontrei MagriSim! Esse líquido me salvou! Me livrei daquela barriga chata e to me sentindo maravilhosa de novo. Invejosas… Eu consegui SIM! Eliminei 8Kg sem flacidez..!",
      author: "Roberta Araújo"
    },
    {
      id: 2,
      image: IMAGE_PATHS.felipe,
      alt: "Felipe Santos",
      text: "Olhar minhas fotos antigas e não me reconhecer foi o choque que eu precisava. Estava acima do peso, sem energia e me escondendo de mim mesmo. Com o MagriSim e dedicação, consegui eliminar 18kg e hoje me sinto outra pessoa. Meu filho até brinca: 'Olha como o papai conseguiu!' e isso não tem preço.",
      author: "Felipe Santos"
    },
    {
      id: 3,
      image: IMAGE_PATHS.renata,
      alt: "Bruna Machado",
      text: "Hoje completa mais um ciclo desde que comecei a mudar a minha vida com o MagriSim! No inicio estava sem crença por tantas tentativas frustradas. Eu tava com 98kg e meu objetivo era 85kg. Hoje estou com 73kg seguindo a manutenção de peso e feliz da vida.",
      author: "Bruna Machado"
    }
  ];

  const Card = ({ item }) => (
    <article className="mgs-reviews__card">
      <div className="mgs-reviews__photo">
        <img src={item.image} alt={item.alt} />
      </div>
      <div className="mgs-reviews__body">
        <p className="mgs-reviews__text">{item.text}</p>
        <span className="mgs-reviews__author">{item.author}</span>
      </div>
    </article>
  );

  const Header = () => (
    <div className="mgs-reviews__head">
      <h2 className="mgs-reviews__title">
        Já são <span className="mgs-reviews__title-gold">+100 mil pessoas</span> que
        usam e recomendam o Magrisim
      </h2>
    </div>
  );

  // MOBILE: Carrossel horizontal com animação automática
  if (isMobile) {
    return (
      <section id="pain-points" className="mgs-reviews">
        <div className="mgs-reviews__inner">
          <Header />
          <div className="mgs-reviews__carousel" ref={mobileRef}>
            {reviews.map((item) => (
              <Card key={`m1-${item.id}`} item={item} />
            ))}
            {reviews.map((item) => (
              <Card key={`m2-${item.id}`} item={item} />
            ))}
            {reviews.map((item) => (
              <Card key={`m3-${item.id}`} item={item} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  // DESKTOP: Grid
  return (
    <section id="pain-points" className="mgs-reviews">
      <div className="mgs-reviews__inner">
        <Header />
        <div className="mgs-reviews__grid">
          {reviews.map((item) => (
            <Card key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainPointsSection;
